<div class="header-popup">
  <button class="btn-close themeComparePopupCloseButton1" mat-mini-fab (click)="closeDialog('')">X</button>
</div>
<div>
  <!-- <mat-dialog-content> -->
  <div class="layout">
    <!-- <mat-card class="example-card" appearance="outlined"> -->
    <img [src]="replaceBucket.replaceBucket(urlImg())" alt="รูปภาพสินค้า" title="รูปภาพสินค้า" loading="lazy" />
    <!-- </mat-card> -->
  </div>
  <!-- </mat-dialog-content> -->
</div>
